module.exports = __webpack_public_path__ + "img/shiba-head-level2.27cc2585.png";